/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnotify_NewInputs */

const en_portalnotify_new = /** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const ar_portalnotify_new = en_portalnotify_new;

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const he_portalnotify_new = en_portalnotify_new;

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const ur_portalnotify_new = en_portalnotify_new;

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const es_portalnotify_new = en_portalnotify_new;

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const fr_portalnotify_new = en_portalnotify_new;

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const de_portalnotify_new = en_portalnotify_new;

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const pt_portalnotify_new = en_portalnotify_new;

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const hi_portalnotify_new = en_portalnotify_new;

/** @type {(inputs: Portalnotify_NewInputs) => LocalizedString} */
const bn_portalnotify_new = en_portalnotify_new;

/**
* | output |
* | --- |
* | "New" |
*
* @param {Portalnotify_NewInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portalnotify_new = /** @type {((inputs?: Portalnotify_NewInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_NewInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portalnotify_new(inputs)
	if (locale === "he") return he_portalnotify_new(inputs)
	if (locale === "ur") return ur_portalnotify_new(inputs)
	if (locale === "es") return es_portalnotify_new(inputs)
	if (locale === "fr") return fr_portalnotify_new(inputs)
	if (locale === "de") return de_portalnotify_new(inputs)
	if (locale === "pt") return pt_portalnotify_new(inputs)
	if (locale === "hi") return hi_portalnotify_new(inputs)
	if (locale === "bn") return bn_portalnotify_new(inputs)
	return /** @type {LocalizedString} */ ("New")
});